import { ComponentMultiStyleConfig, theme as baseTheme } from '@chakra-ui/theme'

import { primaryColor } from '../foundations/primaryColor'

const { modal: { bgColor, bgBorderColor } } = primaryColor

// You can also use the more specific type for
// a single part component: ComponentSingleStyleConfig
export const Modal: ComponentMultiStyleConfig = {
  parts: ['content'],
  // The styles all teext have in common
  baseStyle: {
    ...baseTheme.components.Modal.baseStyle,
    overlay: {
      bg: 'rgba(0, 0, 0, 0.8)'
    },
    dialog: {
      bg: 'transparent',
    },
    dialogContainer: {
      '@supports(height: -webkit-fill-available)': {},
    },
  },
  variants: {
    primary: {
      body: {
        bg: bgColor,
        borderColor: bgBorderColor,
        borderRadius: '8px',
        borderWidth: '3px',
        mx: 4,
      }
    },
    secondary: {
      dialog: {

        shadow: 0,
      }
    }
    // variants
    // The default variant values
  },
  defaultProps: {
    variant: 'primary',
  }
}
